import { editItinerary } from '@/actions/itineraryV2/edit';
import Button from '@/components/ui/Button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from "@/components/ui/Dialog";
import useAppStore from '@/core/stores/app';
import { useItineraryStoreV2 } from '@/core/stores/itinerary/itineraryV2';
import { faGlobe, faLock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import { useEffect, useState } from "react";

const ItinerarySettingsModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { itineraryId, setSettings, settings, } = useItineraryStoreV2()

  const [copied, setCopied] = useState(false);
  const [name, setName] = useState('')

  const [visibility, setVisibility] = useState<'public' | 'private'>('public')




  useEffect(() => {
    if (settings) {
      setVisibility(settings?.visibility)
      setName(settings.title)
    }
  }, [settings])

  const [isSaving, setIsSaving] = useState(false)

  const handleSave = async () => {
    if (!itineraryId) {
      return
    }
    setIsSaving(true)

    const res = await editItinerary({ itineraryId, title: name, visibility })

    const { response, result } = JSON.parse(res)

    if (result && !result.error) {
      setSettings({ title: name, visibility })

    } else {
      if (result.error) {
        // setError(result.error)
      }
    }

    setIsSaving(false)
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCopied(false);
    }, 1500);

    return () => {
      clearTimeout(timeout);
    };
  }, [copied]);

  const { isApp } = useAppStore()


  return <Dialog open={isOpen} onOpenChange={onClose}>
    <DialogContent className="sm:max-w-lg  max-h-dvh overflow-y-auto">
      <Image
        className="w-full aspect-[1/0.7] -scale-x-100 md:hidden absolute left-0 top-0 z-0"
        alt={'Planingo'}
        width={400}
        height={400}
        priority
        src={`${process.env.NEXT_PUBLIC_STORAGE_URL}general/a32f3694-6efa-47f8-8481-4882946ddbaa.png`} />
      <DialogHeader className='relative text-center w-full flex items-center justify-center z-10'>
        <DialogTitle>Trip Setting</DialogTitle>
      </DialogHeader>
      <div className='relative z-20'>
        <div className='p-4'>
          <label htmlFor='trip-name' className='flex flex-col gap-2 pb-4 mb-4 border-b'>
            <span className='text-sm text-gray-800'>Trip Name?</span>
            <input className='newInput' id='trip-name' value={name} onChange={(e) => setName(e.target.value)} />
          </label>
        </div>
        <div>
          <p className="pb-4 text-sm text-gray-800">Privacy</p>
          <div className='flex flex-col gap-4'>
            <label onClick={() => setVisibility('public')} htmlFor='public' className={`${visibility === 'public' ? "border-indigo-500 bg-indigo-50" : "border-neutral-200"} 
          col-span-1 relative p-4 rounded-3xl cursor-pointer border`}>
              <div className='flex justify-center opacity-0 absolute top-0 left-0'>
              </div>
              <div className='grid grid-cols-[24px,_1fr] gap-4 items-center'>

                <span>
                  <FontAwesomeIcon icon={faGlobe} className='w-6' />
                </span>
                <div className='flex gap-1 flex-col'>

                  <span className='text-sm text-gray-900 font-semibold'>Anyone with a link</span>
                  <span className='text-gray-500 font-normal text-xs'>People invited and people with the link can access</span>
                </div>
              </div>
            </label>
            <label onClick={() => setVisibility('private')} htmlFor='private' className={`${visibility === 'private' ? "border-indigo-500 bg-indigo-50" : "border-neutral-200"}
             col-span-1 relative p-4 rounded-3xl cursor-pointer border`}>
              <div className='flex justify-center opacity-0 absolute top-0 left-0'>
              </div>
              <div className='grid grid-cols-[24px,_1fr] gap-4 items-center'>

                <span>
                  <FontAwesomeIcon icon={faLock} className='w-6' />
                </span>
                <div className='flex gap-1 flex-col'>

                  <span className='text-sm text-gray-900 font-semibold'>Invite only</span>
                  <span className='text-gray-500 font-normal text-xs'>Only you and people invited can access</span>
                </div>
              </div>
            </label>
          </div>
        </div>

        <div className='flex items-center justify-between pt-4 mt-4 border-t'>
          <Button onClick={onClose} className='' color='secondary' isActive radius='rounded-xl'>
            Cancel
          </Button>
          <Button isLoading={isSaving} disabled={isSaving}
            onClick={handleSave} color='primary' radius='rounded-xl'>
            Save
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>

};
export default ItinerarySettingsModal;
